import "jquery-validation";
import jQuery from "jquery";
import $ from "jquery";

"use strict";
const valGetParentContainer = function(element) {
    const $element = $(element);

    if ($element.closest(".form-group-sub").length > 0) {
        return $element.closest(".form-group-sub");
    } else if ($element.closest(".bootstrap-select").length > 0) {
        return $element.closest(".bootstrap-select");
    } else if ($element.closest(".dropdown-multiselect").length > 0) {
        return $element.closest(".dropdown-multiselect");
    } else {
        return $element.closest(".form-group");
    }
};

(jQuery as any).validator.setDefaults({
    errorElement: "div", //default input error message container
    focusInvalid: false, // do not focus the last invalid input
    ignore: "", // validate all fields including form hidden input

    errorPlacement: function(error, element) {
        // render error placement for each input type
        const $element = $(element);

        $element.addClass("is-invalid");
        error.addClass("invalid-feedback");

        if ($element.closest(".bootstrap-select").length > 0) {
            //Bootstrap select
            $element
                .closest(".bootstrap-select")
                .find(".bs-placeholder")
                .after(error);
        } else if ($element.closest(".dropdown-multiselect").length > 0) {
            //Bootstrap select
            $element
                .closest(".dropdown-multiselect")
                .find(".dropdown-toggle")
                .after(error);
        } else if ($element.closest(".input-group").length > 0) {
            //Bootstrap group
            $element.closest(".input-group").after(error);
        } else {
            //Checkbox & radios
            if ($element.is(":checkbox")) {
                $element
                    .closest(".kt-checkbox")
                    .find("> span")
                    .after(error);
            } if ($element.is(":radio")) {
                if($element.closest(".kt-radio-inline").length > 0)
                    $element.closest(".kt-radio-inline").parent().append(error);
                if($element.closest(".kt-radio-list").length > 0)
                    $element.closest(".kt-radio-list").parent().append(error);
            } else {
                $element.after(error);
            }
        }
    },

    highlight: function(element) {
        // hightlight error inputs
        const group = valGetParentContainer(element);
        group.addClass("validate");
        group.addClass("is-invalid");
        $(element).removeClass("is-valid");
    },

    unhighlight: function(element) {
        // revert the change done by hightlight
        const group = valGetParentContainer(element);
        group.removeClass("validate");
        group.removeClass("is-invalid");
        $(element).removeClass("is-invalid");
        $(element)
            .closest(".input-group")
            .parent()
            .find(".error.invalid-feedback")
            .remove();
    },

    success: function(label, element) {
        const group = valGetParentContainer(element);
        group.removeClass("validate");
        group.find(".invalid-feedback").remove();
    },
});

(jQuery as any).validator.addMethod(
    "email",
    function(value: string) {
        if(value === "")
            return true;
        
        return /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value);
    },
    "Please enter a valid Email.",
);

(jQuery as any).validator.addMethod(
    "at_least_one_compiled",
    function(_value: string, _element, options) {
        const checkable_field_names = options.field_names;

        let is_validated = false;
        for(const checkable_field_name of checkable_field_names){
            let checkable_field = $(`[name='${checkable_field_name}']`);
            if(checkable_field.length === 0)
                checkable_field = $(`[name='${checkable_field_name}[]']`);

            const field_value = checkable_field.val() as any;
            if(field_value.length !== 0 && field_value !== "" && field_value !== null){
                is_validated = true;
                break;
            }
        }

        return is_validated;
    },
    "Compile at least one of these fields.",
);

(jQuery as any).validator.addMethod(
    "only_alphanumerical_and_spaces",
    function(value: string) {
        if(value === "")
            return true;
        
        return /^[a-zA-Z0-9\s]+$/.test(value);
    },
    "Please enter only numbers and letters.",
);

(jQuery as any).validator.setDefaults({
    ignore: ':hidden'
});